<template>
  <div class="panel-body">
    <div class="form-group m-0 no-print d-print-none">
      <router-link v-if="auth_user.ambiente === 'A'" :disabled="!allow('EMPRESAS')" class="btn btn-sm btn-success"
        tag="button" :to="{ name: `empresaCreate`}">
        <i class="fa fa-plus" aria-hidden="true"></i>
        {{ $t('words.create') }}
      </router-link>
    </div>
    <div class="row">
      <div class="col-md-12 text-center print-only">
        <div id="header">
          <h3 class="m-0"><label class="m-0">{{ auth_user.empresa.empresa_nome }}</label></h3>
          <h3 class="m-0"><label><small>{{ formatDocument(auth_user.empresa.empresa_documento) }}</small></label></h3>
          <h3 class="mx-0 mt-3"><strong>Empresas</strong></h3>
        </div>
      </div>
      <div class="col-md-12">
        <filterable @loading="changeLoading" @handdleCollumn="handdleCollumn" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th class="col-md-1 no-print d-print-none">{{$t('words.options')}}</th>
              <th v-show="checkCollumnVisible('empresa_nome')">{{$t('attributes.name')}}</th>
              <th v-show="checkCollumnVisible('empresa_documento')">{{$t('attributes.cnpj')}}</th>
              <th v-show="checkCollumnVisible('empresa_telefone')">{{$t("attributes.phone")}}</th>
              <th v-show="checkCollumnVisible('is_revenda')">Revenda?</th>
              <th v-show="checkCollumnVisible('revenda.empresa_nome')">Parceiro revenda</th>
              <th v-show="checkCollumnVisible('plano.config.nome')">Desc. Plano</th>
              <th v-show="checkCollumnVisible('plano.valor')">Valor</th>
              <th v-show="checkCollumnVisible('plano.vencimento_padrao')">Vencimento</th>
              <th v-show="checkCollumnVisible('plano.recorrente')">Plano</th>
              <th v-show="checkCollumnVisible('empresa_status')">{{$t("words.status")}}</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button class="btn btn-default btn-sm dropdown-toggle" v-bind:title="$t('words.operations')"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <div class="dropdown-menu">
                  <router-link class="dropdown-item" :to="{ name: `empresaEdit`, params: { id: item.id}}">
                    <i class="fa fa-pencil"></i> {{$t('words.edit')}}
                  </router-link>
                  <router-link class="dropdown-item" :to="{ name: `empresaPlano`, params: { id: item.id}}">
                    <i class="fa fa-credit-card"></i> Plano
                  </router-link>
                  <a v-if="auth_user.ambiente == 'A'" class="dropdown-item" @click="disableCompany(item.id)">
                    <i class="fa fa-times" aria-hidden="true"></i> {{$t('words.disable')}}
                  </a>
                  <a class="dropdown-item" v-if="item.empresa_status == 'D'" @click="disableCompany(item.id)">
                    <i class="fa fa-check" aria-hidden="true"></i> {{$t('words.enable')}}</a>
                  <a v-if="item.plano && item.plano.recorrente" class="dropdown-item" @click="cancelSignature(item)">
                    <i class="fa fa-times-circle"></i> Cancelar Assinatura
                  </a>
                </div>
              </div>
            </td>
            <td v-show="checkCollumnVisible('empresa_nome')">{{item.empresa_nome}}</td>
            <td v-show="checkCollumnVisible('empresa_documento')">{{formatDocument(item.empresa_documento)}}</td>
            <td v-show="checkCollumnVisible('empresa_telefone')">{{formatTelefone(item.empresa_telefone)}}</td>
            <td v-show="checkCollumnVisible('is_revenda')" class="text-center"><i
                :class="(item.is_revenda)?'fa-check':'fa-times'" class="fa"></i></td>
            <td v-show="checkCollumnVisible('revenda.empresa_nome')">{{ (item.revenda)?item.revenda.empresa_nome:'' }}
            </td>
            <td v-show="checkCollumnVisible('plano.config.nome')">
              <span v-if="item.plano">{{ item.plano.config.nome || '' }}</span><span v-else> Sem plano</span>
            </td>
            <td v-show="checkCollumnVisible('plano.valor')">
              <span v-if="item.plano">{{ formatMoney(item.plano.valor || 0) }}</span><span
                v-else>{{ formatMoney(0) }}</span>
            </td>
            <td v-show="checkCollumnVisible('plano.vencimento_padrao')">
              <span v-if="item.plano">{{ formatarData(item.plano.vencimento_padrao) }}</span><span v-else> </span>
            </td>
            <td v-show="checkCollumnVisible('plano.recorrente')">
              <span v-if="!item.plano" class="badge bg-gray">Desconfigurado</span>
              <span v-if="item.plano && !item.plano.recorrente" class="badge bg-red">Desabilitado</span>
              <span v-if="item.plano && item.plano.recorrente" class="badge bg-green">Habilitado</span>
            </td>
            <td v-show="checkCollumnVisible('empresa_status')">
              <span v-if="item.empresa_status == 'E'" class="badge bg-orange">Expirado</span>
              <span v-if="item.empresa_status == 'D'" class="badge bg-red">Desativada</span>
              <span v-if="item.empresa_status == 'A'" class="badge bg-green">Ativada</span>
            </td>
          </tr>
        </filterable>
        <div class="col-md-12 col-sm-12 col-xs-12 text-right text-bold print-only">
          <span class="pull-right" style="display:flex;align-items:center;">
            <strong class="info-box-text">Total: </strong>
            <strong class="info-box-number" style="padding:0 0.5rem;">
              {{ formatMoney(empresas.reduce((a, b) => a +  parseFloat(!b.plano ? 0 : b.plano.valor), 0)) }}
            </strong>
          </span>
        </div>
      </div>
    </div>
    <div id="footer" class="print-only" style="padding:2rem 8px ;">
      <span>Impressão realizada dia: {{formatarData(new Date().toISOString().substring(0, 10)).replace(/-/g,'/') }}
        por {{ auth_user.empresa.empresa_nome }}
      </span>
      <span class="pull-right"> {{ window }} </span>
    </div>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalExport">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4>{{$t('words.export_data')}}</h4>
          </div>
          <div class="modal-body">
            <div class="panel-body">
              <div class="alert flat bg-gray-light alert-dismissible">
                <b>
                  <i class="icon fa fa-info-circle"></i>
                  {{ $t('words.tip')}}
                </b>
                <br>
                {{ $t('message.export_data') }}
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default float-left" data-dismiss="modal">
              <i class="fa fa-times"></i>
              {{$t('words.cancel')}}
            </button>
            <button type="button" @click="confirmExportData()" class="btn btn-success">
              <i class="fa fa-check"></i>
              {{$t('words.save')}}
              <i v-show="loading" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        empresa: {
          municipio: {
            mun_uf: ''
          }
        },
        filterable: {
          url: '/api/empresas',
          storeAction: 'setEmpresas',
          storeName: 'empresa.data',
          model: 'empresa',
          showPrint: true,
          deleted: true,
          headers: [{
              title: 'Nome',
              visible: true,
              name: 'empresa_nome'
            },
            {
              title: 'CNPJ',
              visible: true,
              name: 'empresa_documento'
            },
            {
              title: 'Telefone',
              visible: true,
              name: 'empresa_telefone'
            },
            {
              title: 'Revenda',
              visible: false,
              name: 'is_revenda'
            },
            {
              title: 'Parceiro',
              visible: false,
              name: 'revenda.empresa_nome'
            },
            {
              title: 'Desc. Plano',
              visible: false,
              name: 'plano.config.nome'
            },
            {
              title: 'Valor',
              visible: false,
              name: 'plano.valor'
            },
            {
              title: 'Vecimento',
              visible: false,
              name: 'plano.vencimento_padrao'
            },
            {
              title: 'Plano',
              visible: true,
              name: 'plano.recorrente'
            },
            {
              title: 'Status',
              visible: true,
              name: 'empresa_status'
            },
          ],
        }
      };
    },
    computed: {
      empresas() {
        return this.$store.state.empresa.data;
      },
      user() {
        return this.$store.state.user.data;
      },
      window() {
        return window.location.origin
      },
    },
    watch: {
      $route(data) {
        if (data.name === 'empresas') this.prepareComponent();
        if (data.name === 'empresas' && this.auth_user.ambiente == 'A') this.$store.dispatch('getEmpresaRevenda')
      }
    },
    methods: {
      formatDocument(payload) {
        return (payload && payload.length > 11) ? this.formatCnpj(payload) : this.formatCpf(payload);
      },
      exportData() {
        $('#ModalExport').modal();
      },
      confirmExportData() {
        let token = localStorage.getItem('access_token');
        this.loading = true;
        $.ajax({
            type: 'POST',
            timeout: 3000,
            url: '/api/empresa/exportar',
            headers: {
              authorization: 'Bearer ' + token
            },
            xhrFields: {
              responseType: 'blob'
            }
          })
          .then(response => {
            let blob = new Blob([response], {
              type: 'data:application/vnd.ms-excel'
            });
            let downloadUrl = URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'Exportação PDVx - Empresa.xls';
            document.body.appendChild(a);
            a.click();
            toastr({
              icon: 'success',
              title: 'Exportação realizada com sucesso.'
            });
            this.loading = false;
            $('#ModalExport').modal('hide');
          })
          .catch(error => {
            console.log('erro', error);
          });
      },
      getById(payload) {
        this.filterable.loading = true;
        this.$store.dispatch('getEmpresaById', payload).then(response => {
          this.filterable.loading = false;
          this.empresa = response;
          $('#ModalShowData').modal('toggle');
        });
      },
      getCrt(payload) {
        switch (payload) {
          case '1':
            return trans('words.crt_1');
          case '2':
            return trans('words.crt_2');
          case '3':
            return trans('words.crt_3');
          default:
            return payload;
        }
      },
      disableCompany(payload) {
        this.isLoading = true;
        this.$store.dispatch('disableCompany', payload).then(response => {
          this.isLoading = false;
          if (response.status === 'success') {
            this.$store.commit('UPDATE_EMPRESA_LIST', payload);
          }
          toastr({
            icon: response.status,
            title: response.message
          });
        });
      },
      cancelSignature(item) {
        Swal.fire({
          title: trans('words.atention'),
          html: `Você está cancelando a assinatura da empresa <b>${item.empresa_nome}</b><br>
          <small> OBS: Confirmando, sua assinatura não irá ser renovada e seu acesso <b>será bloqueado após o vencimento.</b></small>`,
          icon: 'warning',
          input: 'text',
          inputPlaceholder: 'Digite CONFIRMA para continuar',
          showCancelButton: true,
          allowOutsideClick: true,
          cancelButtonText: trans('words.close'),
          confirmButtonText: 'Confirmar',
          confirmButtonClass: 'btn btn-danger btn-lg float-right',
          cancelButtonClass: 'btn btn-default btn-lg float-left',
          buttonsStyling: false,
          reverseButtons: true,
          showLoaderOnConfirm: true,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value !== 'CONFIRMA') {
                resolve('Por favor, digite a palavra `CONFIRMA` para continuar');
              } else {
                resolve();
              }
            });
          },
          preConfirm: (confirm) => {
            return this.$store.dispatch('cancelSignature', item.id);
          }
        }).then(response => {
          switch (response.value.status) {
            case 'success':
              toastr({
                icon: 'success',
                title: 'Cancelamento de assinatura',
                html: response.value.message,
                showCancelButton: true,
                confirmButtonClass: 'btn btn-default btn-lg float-right',
                cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                buttonsStyling: false,
                confirmButtonText: trans('words.close'),
                reverseButtons: true
              });
              this.prepareComponent();
              break;
            default:
              toastr({
                icon: response.value.status,
                title: 'Cancelamento de assinatura',
                html: response.value.message,
                showCancelButton: true,
                allowOutsideClick: true,
                cancelButtonText: trans('words.close'),
                confirmButtonText: trans('words.close'),
                confirmButtonClass: 'btn btn-default btn-lg float-right',
                cancelButtonClass: 'btn btn-default btn-lg float-left invisible',
                buttonsStyling: false,
                reverseButtons: true
              });
              break;
          }
        });
      },
    }
  };
</script>